import React, { useState } from 'react';
import axiosInstance from '../../../utils/router/axiosInstance';
import './addWifiDot.css';
import { logger } from '../../../utils/logger';

// WEB-5: initialX/initialY — префилл координат (метры) из клика по плану,
// onCreated — колбэк успешного создания (вместо window.location.reload),
// isPageAlive — гард alert'ов по состоянию РОДИТЕЛЯ (ревью Codex: поздний
// ответ POST после ухода со страницы карты всплывал alert'ом поверх чужой
// страницы; сам модал не отличает «закрыли модал» от «ушли со страницы»).
// Легаси-вызов (userColibrate) не передаёт ни одного из этих props —
// поведение байт-в-байт: ручные X/Y + alert + reload. Компонент ремоунтится
// родителем по key на каждый клик, initial-значения достаточно useState.
const ModalAddWifiDot = ({ building_id, floor_id, initialX, initialY, onCreated, isPageAlive }) => {
  const hasPrefill = Number.isFinite(Number(initialX)) && Number.isFinite(Number(initialY));
  const canNotify = () => !isPageAlive || isPageAlive();
  const [formData, setFormData] = useState({
    ssid: '',
    bssid: '',
    building_id: 0,
    floor_id: 0,
    x: hasPrefill ? Number(initialX) : 0,
    y: hasPrefill ? Number(initialY) : 0,
    A: 0,
    n: 0,
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      const response = await axiosInstance.post('website/dots', {
        ssid: formData.ssid,
        bssid: formData.bssid,
        building_id: building_id,
        floor: floor_id,
        x: formData.x,
        y: formData.y,
        A: parseFloat(formData.A),
        n: parseFloat(formData.n),
      });

      if (response.status === 200) {
        if (canNotify()) alert('Wifi точка успешно добавлена');
        if (onCreated) {
          onCreated(response.data);
        } else {
          window.location.reload();
        }
      } else if (response.status === 418) {
        if (canNotify()) alert('Данная точка уже существует');
      } else {
        if (canNotify()) alert(`Ошибка: ${response.status}`);
      }

      // Reset the form data after successful submission
      setFormData({
        ssid: '',
        bssid: '',
        building_id: 0,
        floor: 0,
        x: 0,
        y: 0,
        A: 0,
        n: 0,
      });
    } catch (error) {
      if (error.response && error.response.status === 418) {
        if (canNotify()) alert('Данная точка уже существует');
      } else {
        logger.error('Error submitting form:', error);
        if (canNotify()) alert(`Ошибка: ${error.response ? error.response.status : 'Unknown'}`);
      }
    }
  };

  return (
    <div className="addWifiDot">
      <label>
        SSID:
        <input
          className="inputWifi"
          type="text"
          name="ssid"
          value={formData.ssid}
          onChange={handleInputChange}
        />
      </label>
      <label>
        BSSID:
        <input
          className="inputWifi"
          type="text"
          name="bssid"
          value={formData.bssid}
          onChange={handleInputChange}
        />
      </label>
      {hasPrefill && (
        <p className="addWifiDotPrefill">
          Координаты из клика: X={formData.x} м, Y={formData.y} м
        </p>
      )}
      {hasPrefill ? (
        <details className="addWifiDotExpert">
          <summary>Эксперт: ручной X/Y</summary>
          <label>
            X (в метрах):
            <input className="inputWifi" type="number" name="x" value={formData.x} onChange={handleInputChange} />
          </label>
          <label>
            Y (в метрах):
            <input className="inputWifi" type="number" name="y" value={formData.y} onChange={handleInputChange} />
          </label>
        </details>
      ) : (
        <>
          <label>
            X (в метрах):
            <input className="inputWifi" type="number" name="x" value={formData.x} onChange={handleInputChange} />
          </label>
          <label>
            Y (в метрах):
            <input className="inputWifi" type="number" name="y" value={formData.y} onChange={handleInputChange} />
          </label>
        </>
      )}
      <label>
        N:
        <input className="inputWifi" type="number" name="n" value={formData.n} onChange={handleInputChange} />
      </label>
      <label>
        A:
        <input className="inputWifi" type="number" name="A" value={formData.A} onChange={handleInputChange} />
      </label>
      <button className="btnWifi" onClick={handleSubmit}>
        Добавить
      </button>
    </div>
  );
};

export default ModalAddWifiDot;
